<template>
  <div class="data-table-list-client" :class="size" v-if="activate >= 15 || activate == 11">
    <el-dropdown trigger="click" placement="bottom-start" :hide-on-click="false" @visible-change="dropdown = id">
      <el-tooltip content="メンバーを追加" placement="top" :disabled="!size">
        <div class="pointer flex-row" style="margin-left:10px;" v-if="list.member_count > 0">
          <div class="flex-row" v-for="member in list.member" :key="member.id">
            <img :src="member.img_url" class="list-member-profile" :class="size" v-if="member.img_url != null && member.assign == true" />
            <div v-if="member.img_url == null && member.assign == true" class="list-member-noimg assign" :class="size">{{ member.person_name | firstLetter }}</div>
          </div>
        </div>
        <div class="data-table-list-status-button pointer" v-else>
          <div class="list-member-user" :class="size">
            <font-awesome-icon icon="user" :class="size ? 'list-member-user-icon--small' : ''" />
            <font-awesome-icon icon="plus-circle" class="list-member-plus" :class="size" />
          </div>
        </div>
      </el-tooltip>
      <el-dropdown-menu slot="dropdown">
        <div v-if="dropdown == id">
          <el-dropdown-item
            style="font-size:12px;"
            v-for="(member, member_index) in list.member"
            :key="member.person_id"
            class="member"
            @click.native="member.assign == true ? '' : addMember(member.person_id, member_index, id, index)"
            :class="member.assign == true ? 'assign' : ''"
          >
            <img :src="member.img_url" class="list-member-profile dropdown" v-if="member.img_url != null" />
            <div class="list-member-noimg dropdown" v-else>{{ member.person_name | firstLetter }}</div>
            <div class="list-member-dropdown-namearea">
              <div>{{ member.person_name }}</div>
              <div v-if="member.assign == true">
                <div class="pointer times-circle" @click="deleteMember(member.person_id, member_index, id, index)">
                  <font-awesome-icon icon="times-circle" />
                </div>
              </div>
            </div>
          </el-dropdown-item>
          <router-link :to="{ name: 'setting', query: { activeName: 'member' } }">
            <el-dropdown-item :divided="list.member.length > 0">
              <i class="el-icon-plus"></i>
              メンバーを追加する
            </el-dropdown-item>
          </router-link>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "memberDropdown",
  props: ["id", "list", "index", "size"],
  data() {
    return {
      dropdown: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  methods: {
    addMember(person_id, member_index, list_id, index) {
      this.$emit("addMember", person_id, member_index, list_id, index);
    },
    deleteMember(person_id, member_index, list_id, index) {
      this.$emit("deleteMember", person_id, member_index, list_id, index);
    },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>

<style></style>
